/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import "./../OutletScreen/OutletScreen.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getUserSummary } from "../../redux/actions/getUserSummary";
import { getTerminalsByUserId } from "../../redux/actions/getTerminalsByUserId";
import { getOutletsByMerchant } from "../../redux/actions/getOutletsByMerchant";
import {
  getTransactionsByUserId,
  RemoveUserTransactions,
} from "../../redux/actions/getTransactionsByUserId";
import { RootState } from "../../redux/rootReducers";
import TransactionsTable from "../../components/TransactionTable";
import TerminalsTable from "../../components/TerminalTable";
import { MerchantEx, User } from "../../models";
import { useTranslation } from "react-i18next";
import DynamicTab from "../../CustomComponent/DynamicTab/DynamicTab";
import FilterTransaction from "../../components/FilterTransaction/FilterTransaction";
import Layout from "../Layout/Layout";
import DataSpinner from "../../CustomComponent/Spinner/Spinner";
import useFilterTransactionHook from "../../CustomHooks/useFilterTransactionHook";
import "./UserDetail.scss";
import { RefreshIcon } from "../../components/Icons/paymentGateway";
import { capitalizeFirstLetter } from "../../components/commonFunctions";

const UserPartnerScreen = () => {
  // Hooks
  const { id }: any = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation("translation", { keyPrefix: "userScreen" });
  // Api's
  const authApi = useSelector((state: RootState) => state.authReducer);
  const merchantApi: {
    merch_id: string;
    merchantData: MerchantEx;
    loading: boolean;
    error: null | string;
  } = useSelector((state: RootState) => state.merchantReducer);
  const getUserSummaryApi = useSelector(
    (state: RootState) => state.userSummaryReducer
  );
  //const getUsersApi = useSelector((state: RootState) => state.getUsersReducer);
  //const keyclockId = getUsersApi.users?.filter((user: User) => user.userId === id)[0].keycloakUserId;
  const getTerminalsByUserApi: {
    terminals: [];
    loading: false;
    error: null;
  } = useSelector((state: RootState) => state.getUsersTerminalsReducer);

  const [
    transactionApi,
    getFilteredTransactionHook,
    ResetFilterReducer,
    handleRefreshTransactionFilter,
  ]: any = useFilterTransactionHook(
    authApi.token,
    merchantApi.merch_id,
    id,
    "",
  );

  const outletsApi = useSelector(
    (state: RootState) => state.outLetsByMerchantReducer,
  );

  const [activeTab, setActiveTab] = useState("Transactions");
  const tabs = [
    { name: "Transactions", value: t("tabs.operations") },
    { name: "Terminals", value: t("tabs.terminals") },
  ];
  const [filterTrx, setFilterTrx] = useState(false);

  // Get User Summary

  useEffect(() => {
    dispatch(getUserSummary(authApi.token, id));
  }, [authApi.token, dispatch, id]);

  // Get Terminals By User ID

  useEffect(() => {
    dispatch(getTerminalsByUserId(authApi.token, id /* keyclockId */));
  }, [authApi.token, dispatch, id /* keyclockId */]);

  // Get Transactions By User Id
  useEffect(() => {
    dispatch(getTransactionsByUserId(authApi.token, id /* keyclockId */));
  }, [authApi.token, dispatch, id /* keyclockId */]);

  // Get Outlet By Merchant Id

  useEffect(() => {
    dispatch(getOutletsByMerchant(authApi.token, merchantApi.merch_id));
  }, [dispatch, authApi.token, merchantApi.merch_id]);

  useEffect(() => {
    return () => {
      dispatch(RemoveUserTransactions());
      // ResetFilterReducer();
    };
  }, []);

  const toggleFilterTRX = () => {
    setFilterTrx(!filterTrx);
  };

  // Render Tables
  const renderOperations = () => {
    return (
      <TransactionsTable
        type="read"
        data={transactionApi}
        getFilteredTransaction={getFilteredTransactionHook}
      />
    );
  };

  const renderTerminal = () => {
    return (
      <TerminalsTable
        type="read"
        data={getTerminalsByUserApi}
        subData={outletsApi}
      />
    );
  };

  // Handle Reload Data from api's

  const handleReload = () => {
    dispatch(getTerminalsByUserId(authApi.token, id /* keyclockId */));
    handleRefreshTransactionFilter();
    dispatch(getTransactionsByUserId(authApi.token, id /* keyclockId */));
    dispatch(getOutletsByMerchant(authApi.token, merchantApi.merch_id));
  };
  const renderTabdata = useCallback(
    (type?: string) => {
      if (type === "Transactions") {
        return renderOperations();
      } else if (type === "Terminals") {
        return renderTerminal();
      } else {
        return renderOperations();
      }
    },
    [activeTab, tabs],
  );

  return (
    <Layout type="merchant">
      <div id="user" className="content-side UserDetailWrapper">
        <div className="merchant-container">
          {getUserSummaryApi.loading ||
          (!getUserSummaryApi.userSummary && !getUserSummaryApi.error) ? (
            <DataSpinner />
          ) : getUserSummaryApi.error ? (
            <h5>{t("error")}</h5>
          ) : (
            <>
              <div className="header">
                <div className="breadCrumb">
                  {t("softpos")} / {t("users")} /{" "}
                  {`${getUserSummaryApi.userSummary?.firstName}  ${getUserSummaryApi.userSummary.lastName}`}
                </div>
                <div className="heading">
                  <div className="font-h2">
                    {`${capitalizeFirstLetter(
                      getUserSummaryApi.userSummary?.firstName,
                    )}  ${capitalizeFirstLetter(
                      getUserSummaryApi.userSummary.lastName,
                    )}`}{" "}
                    <p>
                      {t("cards.userEmail")} :{" "}
                      {getUserSummaryApi.userSummary.email} | {t("role")} :{" "}
                      {capitalizeFirstLetter(
                        getUserSummaryApi.userSummary.role,
                      )}{" "}
                      | {t("status")} : {getUserSummaryApi.userSummary.status}
                    </p>
                  </div>
                  <div className=" header-buttons">
                    <div className="round">
                      <button
                        className="button-secondary-light round"
                        onClick={() => {
                          handleReload();
                        }}
                      >
                        <RefreshIcon />
                      </button>
                    </div>

                    {/* <button
                      className="button-secondary-light"
                      onClick={() => {
                        setIsComponentVisible(true);
                      }}
                    >
                      <FilterIcon />
                      Filter
                    </button> */}
                  </div>
                </div>
              </div>
            </>
          )}
          <DynamicTab
            tabs={tabs}
            activeTab={activeTab}
            setActive={setActiveTab}
            renderTabdata={renderTabdata}
          />
        </div>
      </div>
      {filterTrx && <FilterTransaction toggleFilterTRX={toggleFilterTRX} />}
    </Layout>
  );
};

export default UserPartnerScreen;
